// noinspection ES6UnusedImports
import React, {useEffect, useRef, useState} from 'react';
import {Select} from '@bonprix/design-system';
import Landmark from '@core/scripts/components/landmark-adapter';

const CLICK_LANDMARK_VALUE_MAPPING = {
    SIZE: 'adp_reviews_size',
    BODY_HEIGHT: 'adp_reviews_height',
    VARIANT: 'adp_reviews_variant',
};


export default function ReviewToggleFilterSelect({
    filter,
    selectedFilters,
    text,
    defaultFilterValue,
    onFilter,
    onRemoveFilter,
}) {

    const onValueChange = (value) => {

        const clickLandMarkValue = CLICK_LANDMARK_VALUE_MAPPING[filter.type];
        if (clickLandMarkValue) {
            Landmark.sendClickLandmark(clickLandMarkValue);
        }

        if (selectedFilters[filter.type] !== value && defaultFilterValue !== value) {
            return onFilter?.({type: filter.type, value});
        }
        return onRemoveFilter?.({type: filter.type, value});
    };

    const currentFilterValue = selectedFilters[filter.type] ? selectedFilters[filter.type] : defaultFilterValue;

    const filterValuesWithDefault = [{value: defaultFilterValue}].concat(filter.values);

    return (
        <div className={'mb-4 mt-4'}>
            <Select label={text} value={currentFilterValue} onValueChange={onValueChange}>
                {filterValuesWithDefault.map((filterValue, index) => {
                    const filterValueValue = filterValue.value;
                    const active = selectedFilters[filter.type] === filterValueValue;

                    return (
                        <Select.Item key={index} value={filterValueValue}
                                     selected={active}>{filterValueValue}</Select.Item>
                    );
                })}
            </Select>
        </div>
    );
}
